<div class="flex flex-col lg:flex-row h-full w-full bg-white overflow-hidden relative border-t border-gray-200">
    <!-- Mobile Backdrop -->
    @if(isMobileCartExpanded()) {
    <div class="fixed inset-0 bg-black/50 z-20 lg:hidden transition-opacity duration-300"
        (click)="isMobileCartExpanded.set(false)">
    </div>
    }

    <!-- Left Column: Product Selection OR Payment Selection -->
    <div class="flex flex-col min-h-0 bg-white h-full overflow-hidden transition-all duration-300"
        [class.hidden]="isMobileCartExpanded()" [class.lg:flex]="isMobileCartExpanded()" [class.flex-1]="true">

        @if (viewMode() === 'register') {
        <!-- Header Row -->
        <div class="flex h-[50px] border-b border-gray-300 bg-white flex-shrink-0">
            <div class="hidden md:flex 2xl:hidden">
                <div
                    class="w-40 h-full flex items-center justify-center border-r border-gray-300 bg-white flex-shrink-0">
                    <div
                        class="w-10 h-10 bg-[#2C3E50] rounded-lg flex items-center justify-center transform rotate-45 shadow-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="text-white transform -rotate-45">
                            <rect width="18" height="18" x="3" y="3" rx="2" />
                            <path d="M3 9h18M9 21V9" />
                        </svg>
                    </div>
                </div>
            </div>

            <div class="flex-1 flex items-center  gap-0 overflow-x-auto overflow-y-hidden h-full">
                @for (tab of posTabs(); track tab.l_CLASS_CD; let i = $index) {
                <button (click)="selectCategory(tab)"
                    class="flex-1 h-[50px] border-t-0 border-b-0  transition-all whitespace-nowrap border-y border-r border-gray-300"
                    [class.bg-gray-600]="selectedCategory().code === tab.l_CLASS_CD && !searchTerm()"
                    [class.text-white]="selectedCategory().code === tab.l_CLASS_CD && !searchTerm()"
                    [class.shadow-inner]="selectedCategory().code === tab.l_CLASS_CD && !searchTerm()"
                    [class.bg-white]="selectedCategory().code !== tab.l_CLASS_CD || searchTerm()"
                    [class.hover:bg-gray-50]="selectedCategory().code !== tab.l_CLASS_CD || searchTerm()">
                    <span class="pl-2 pr-2 w-full">{{ tab?.l_CLASS_NM | translate }}</span>
                </button>
                }
            </div>
            <!-- <div class="flex items-center px-4 border-l border-gray-300 flex-shrink-0">
                <div class="relative transition-all duration-300 overflow-hidden" [class.w-32]="searchTerm()"
                    [class.md:w-48]="searchTerm()" [class.w-10]="!searchTerm()">
                    @if (searchTerm()) {
                    <div class="relative w-full">
                        <input id="searchInput" type="text" [ngModel]="searchTerm()"
                            (ngModelChange)="searchTerm.set($event)"
                            class="w-full pl-3 pr-8 py-2 bg-gray-100 rounded-lg  outline-none"
                            [placeholder]="'pos.search' | translate" />
                        <button (click)="clearSearch()" class="absolute right-2 top-1/2 -translate-y-1/2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="text-gray-500">
                                <path d="M18 6 6 18" />
                                <path d="m6 6 12 12" />
                            </svg>
                        </button>
                    </div>
                    } @else {
                    <button (click)="startSearch()" class="p-2 hover:bg-gray-100 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="text-gray-500">
                            <circle cx="11" cy="11" r="8" />
                            <path d="m21 21-4.3-4.3" />
                        </svg>
                    </button>
                    }
                </div>
            </div> -->
        </div>

        <div class="flex-1 flex flex-col md:flex-row min-h-0">
            <!-- Vertical Sidebar for TABLET (md to lg) -->
            @if (!searchTerm()) {
            <div
                class="hidden md:flex 2xl:hidden flex-col w-40 bg-white border-r border-gray-200 p-2 space-y-1 shrink-0 overflow-y-auto">
                @for (g of currentGroups(); track g.s_CLASS_CD) {
                <button (click)="selectGroup(g)"
                    class="w-full text-center px-3 py-3 rounded-lg transition-colors border text-ellipsis"
                    [class.font-bold]="selectedGroup().code === g.s_CLASS_CD"
                    [class.text-white]="selectedGroup().code === g.s_CLASS_CD"
                    [class.border-gray-600]="selectedGroup().code === g.s_CLASS_CD"
                    [class.bg-gray-600]="selectedGroup().code === g.s_CLASS_CD"
                    [class.shadow-sm]="selectedGroup().code === g.s_CLASS_CD"
                    [class.text-gray-800]="selectedGroup().code === g.s_CLASS_CD"
                    [class.bg-gray-100]="selectedGroup().code !== g.s_CLASS_CD"
                    [class.border-gray-200]="selectedGroup().code !== g.s_CLASS_CD"
                    [class.hover:bg-gray-200]="selectedGroup().code !== g.s_CLASS_CD">
                    {{ g.s_CLASS_NM }}
                </button>
                }
            </div>
            }

            <!-- Main Content (Filters for PC/Mobile + Product list) -->
            <div class="flex-1 flex flex-col min-h-0">
                <!-- Horizontal Filter for PC (lg and up) -->
                @if (!searchTerm()) {
                <div class="hidden 2xl:flex flex-shrink-0 whitespace-nowrap  overflow-x-auto">
                    @for (g of currentGroups(); track g.s_CLASS_CD) {
                    <button (click)="selectGroup(g)"
                        class="flex-1 h-[40px] border-t-0 border-b transition-all whitespace-nowrap border-y border-r border-gray-300"
                        [class.bg-gray-600]="selectedGroup().code === g.s_CLASS_CD && !searchTerm()"
                        [class.text-white]="selectedGroup().code === g.s_CLASS_CD && !searchTerm()"
                        [class.shadow-inner]="selectedGroup().code === g.s_CLASS_CD && !searchTerm()"
                        [class.bg-white]="selectedGroup().code !== g.s_CLASS_CD || searchTerm()"
                        [class.hover:bg-gray-50]="selectedGroup().code !== g.s_CLASS_CD || searchTerm()">
                        <span class="pl-2 pr-2 w-full">{{ g?.s_CLASS_NM | translate }}</span>
                    </button>
                    <!-- <button (click)="selectGroup(g)" class="p-2 whitespace-nowrap border-y border-r min-w-[70px]"
                        [class.font-bold]="selectedGroup().code === g.s_CLASS_CD"
                        [class.text-white]="selectedGroup().code === g.s_CLASS_CD"
                        [class.bg-gray-700]="selectedGroup().code === g.s_CLASS_CD"
                        [class.border-b-2]="selectedGroup().code === g.s_CLASS_CD"
                        [class.border-gray-800]="selectedGroup().code === g.s_CLASS_CD">
                        {{ g.s_CLASS_NM }}
                    </button> -->
                    }
                </div>
                }

                <!-- Horizontal Filter for MOBILE (hidden on md and up) -->
                @if (!searchTerm()) {
                <div class="md:hidden flex-shrink-0 flex items-center px-4 py-2 gap-x-8 bg-white border-b border-gray-200 overflow-x-auto"
                    style="scrollbar-width: none;">
                    @for (g of currentGroups(); track g.s_CLASS_CD) {
                    <button (click)="selectGroup(g)" class="py-2  whitespace-nowrap transition-colors"
                        [class.font-bold]="selectedGroup().code === g.s_CLASS_CD"
                        [class.text-gray-800]="selectedGroup() === g.s_CLASS_CD">
                        {{ g.s_CLASS_NM }}
                    </button>
                    }
                </div>
                }

                <!-- Product List Area -->
                <div class="flex-1 flex flex-col min-h-0 bg-[#F8F8F8] pb-20 lg:pb-0 overflow-y-auto">
                    <app-product-list [products]="displayProducts()" [isLoading]="isDataLoading()"
                        (addToCart)="addToCart($event)" [l_ClassName]="selectedCategory()?.name"
                        [s_ClassName]="selectedGroup()?.name">
                    </app-product-list>
                </div>
            </div>
        </div>

        } @else {
        <div class="flex flex-col h-full bg-white relative">
            @if (processingPayment()) {
            <div class="absolute inset-0 bg-black/50 z-50 flex flex-col items-center justify-center text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="animate-spin mb-4">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                <p class=" font-bold">Processing Transaction...</p>
            </div>
            }
            @if (paymentStep() !== 'complete') {
            <div class="h-[50px] bg-[#707070] flex items-center px-6 justify-between flex-shrink-0 relative">
                <button
                    (click)="paymentStep() === 'selection' ? viewMode.set('register') : paymentStep.set('selection'); refershCash()"
                    class="flex items-center gap-2 text-white/90 hover:text-white transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="m11 17-5-5 5-5" />
                        <path d="m18 17-5-5 5-5" />
                    </svg>
                    <span class=" font-bold">{{ 'PAYMESTR0001' | translate }}</span>
                </button>
                @if (paymentStep() === 'card' || paymentStep() === 'cash' || paymentStep() === 'easypay' ||
                paymentStep() === 'points') {
                }
            </div>
            }

            <div class="flex-1 overflow-y-auto p-8 h-full flex flex-col">
                @switch (paymentStep()) {
                @case ('selection') {
                <div class="flex-1 min-h-0">
                    <div
                        class="flex flex-col md:flex-row justify-between items-center border-b-2 border-gray-100 pb-8 mb-8 gap-4 md:gap-0">
                        <div
                            class="text-center flex-1 w-full border-b md:border-b-0 md:border-r border-gray-200 pb-4 md:pb-0">
                            <div class=" font-bold text-gray-500 mb-2">{{ 'PAYMESTR0002' | translate }}
                            </div>
                            <div class="fs-26 fw-600 text-gray-900">{{ totalPayment() |
                                number }} {{'USERMAG0048' | translate}}</div>
                        </div>
                        <div
                            class="text-center flex-1 w-full border-b md:border-b-0 md:border-r border-gray-200 pb-4 md:pb-0">
                            <div class=" font-bold text-gray-500 mb-2">{{ 'PAYMESTR0003' | translate }}
                            </div>
                            <div class="fs-26 fw-600 text-gray-900">{{ totalPayment() |
                                number }} {{'USERMAG0048' | translate}}</div>
                        </div>
                        <div class="text-center flex-1 w-full">
                            <div class=" font-bold text-gray-500 mb-2">{{ 'PAYMESTR0004' | translate }}
                            </div>
                            <div class="fs-26 fw-600 text-gray-900">{{ totalPayment() |
                                number }} {{'USERMAG0048' | translate}}</div>
                        </div>
                    </div>

                    <div
                        class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 min-h-[250px] border-b-2 border-gray-100 pb-8 mb-8">
                        <!-- Card Payment -->
                        <button
                            (click)="resetIdempotencyKey();paymentStep.set('card'); selectedPaymentMethod.set(paymentType.Card);"
                            class="bg-white rounded-2xl border-2 border-gray-100 p-6 flex flex-col justify-between hover:border-indigo-500 hover:shadow-lg transition-all group text-left relative overflow-hidden h-32 md:h-auto">
                            <div class="flex justify-between items-start relative z-10">
                                <div>
                                    <span class="text-gray-800 block mb-1">{{
                                        'PAYMESTR0005' | translate }}</span>
                                    <span class=" text-gray-500 fs-12">{{ 'PAYMESTR0006' |
                                        translate }}</span>
                                </div>
                                <img src="../../assets/icons/Card.svg" width="50" height="50" alt="">
                            </div>
                        </button>
                        <!-- Cash, EasyPay, Points buttons would follow a similar structure -->
                        <button
                            (click)="resetIdempotencyKey();paymentStep.set('cash'); selectedPaymentMethod.set(paymentType.Cash);RECV_AMT = totalPayment()"
                            class="bg-white rounded-2xl border-2 border-gray-100 p-6 flex flex-col justify-between hover:border-emerald-500 hover:shadow-lg transition-all group text-left relative overflow-hidden h-32 md:h-auto">
                            <div class="flex justify-between items-start relative z-10">
                                <div><span class=" font-bold text-gray-800 block mb-1">{{
                                        'PAYMESTR0007' | translate }}</span><span class=" text-gray-500 fs-12">{{
                                        'PAYMESTR0008' |
                                        translate }}</span></div>
                                <img src="../../assets/icons/Cash.svg" width="50" height="50" alt="">
                            </div>
                        </button>
                        <button
                            (click)="resetIdempotencyKey();paymentStep.set('easypay'); selectedPaymentMethod.set(paymentType.EasyPay);visibleEasypayment = true"
                            class="bg-white rounded-2xl border-2 border-gray-100 p-6 flex flex-col justify-between hover:border-amber-400 hover:shadow-lg transition-all group text-left relative overflow-hidden h-32 md:h-auto">
                            <div class="flex justify-between items-start relative z-10">
                                <div><span class=" font-bold text-gray-800 block mb-1">{{
                                        'PAYMESTR0009' | translate }}</span><span class=" text-gray-500 fs-12">{{
                                        'PAYMESTR0010' |
                                        translate }}</span></div>
                                <img src="../../assets/icons/Card.svg" width="50" height="50" alt="">
                            </div>
                        </button>
                        @if(member() && store()?.savE_CHARGE_FG == '0'){
                        <button
                            (click)="resetIdempotencyKey();paymentStep.set('points');  selectedPaymentMethod.set(paymentType.Points);"
                            class="bg-white rounded-2xl border-2 border-gray-100 p-6 flex flex-col justify-between hover:border-purple-500 hover:shadow-lg transition-all group text-left relative overflow-hidden h-32 md:h-auto">
                            <div class="flex justify-between items-start relative z-10">
                                <div><span class=" font-bold text-gray-800 block mb-1">{{
                                        'PAYMESTR0011' | translate }}</span></div>
                                <img src="../../assets/icons/Easypay.svg" width="50" height="50" alt="">
                            </div>
                        </button>
                        }
                    </div>
                    <div class="font-bold">{{'PAYMESTR0038' | translate}}</div>
                    <div class="flex flex-col md:flex-row gap-4 md:gap-6">
                        <div class="flex items-center gap-4">
                            <span class="flex items-center text-ellipsis w-[200px]">{{'PAYMESTR0039' |
                                translate}}</span>
                            <input type="text" class="input-text h-[40px] fs-14" [value]="member()?.hP_NO | phoneFormat"
                                disabled>
                            <button class="btn-custom h-[40px]" (click)="openMemberSearch.set(true)">{{'PAYMESTR0044' |
                                translate}}</button>
                            <button class="btn-custom h-[40px]" (click)="member.set(null)">{{'PAYMESTR0069' |
                                translate}}</button>
                        </div>
                        @if(member()){
                        <div class="flex justify-start w-full">
                            <div class="flex gap-4">
                                <div>
                                    <p class="flex gap-2"><i
                                            class="pi pi-circle-fill fs-8 flex items-center"></i>{{'PAYMESTR0040' |
                                        translate}}</p>
                                    <p class="flex gap-2"><i
                                            class="pi pi-circle-fill fs-8 flex items-center"></i>{{'PAYMESTR0041' |
                                        translate}}</p>
                                    <p class="flex gap-2"><i
                                            class="pi pi-circle-fill fs-8 flex items-center"></i>{{'PAYMESTR0042' |
                                        translate}}</p>
                                    <p class="flex gap-2"><i
                                            class="pi pi-circle-fill fs-8 flex items-center"></i>{{'PAYMESTR0043' |
                                        translate}}</p>
                                </div>

                                <div class="flex-1">
                                    <p> {{member().membeR_NM}}</p>
                                    <p>{{member().hP_NO | phoneFormat}}</p>
                                    <p [class]="member().membeR_TP_NM ? 'opacity-1' : 'opacity-0'">
                                        {{member().membeR_TP_NM ?? 'None'}}</p>
                                    <p>{{(member().avaiL_POINT ?? 0) | number}}</p>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
                }
                @case('card') {
                <div class=" flex flex-col h-full items-center">
                    <div class="w-full flex justify-between items-end border-b-2 border-gray-100 pb-6 mb-12">
                        <div class="text-left">
                            <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0036' |
                                translate }}</div>
                            <div class="fs-26 fw-600 text-gray-900">{{ totalPayment() |
                                number }} {{ 'USERMAG0048' | translate}}</div>
                        </div>

                        <div class="text-right flex gap-4 ">
                            <div class="text-center">
                                <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0050' |
                                    translate }}</div>
                                <div class="font-extrabold text-gray-900">
                                    <input type="text" class="w-[100px] h-[40px] fs-26 fw-600" pInputText min="0"
                                        [ngModel]="mon_cnt" (input)="onInputMonCNT($event)"
                                        (keydown)="onKeyDownMonCNT($event)">
                                </div>
                            </div>
                            <div class="text-center">
                                <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0015' |
                                    translate }}</div>
                                <input type="text" class="w-[200px] h-[40px] fs-26 fw-600" pInputText min="0"
                                    [value]="(totalPayment() | number) + ' ' + ('USERMAG0048'| translate)" disabled>
                                <!-- <div class=" text-gray-900 fs-26 fw-600">{{ totalPayment() |
                                    number }}{{'USERMAG0048' | translate}}</div> -->
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 flex items-center justify-center mb-12 p-8">
                        <div class="relative">
                            <div
                                class="w-32 h-48 border-4 border-black rounded-2xl flex flex-col items-center p-2 bg-white">
                                <div class="w-full h-16 bg-gray-100 rounded mb-2 flex items-center justify-center">
                                    <div
                                        class="w-12 h-8 border-2 border-black rounded flex items-center justify-center">
                                        <div class="w-8 h-1 bg-black rounded-full"></div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-3 gap-1 mb-2">@for(i of [1,2,3,4,5,6,7,8,9]; track i) {<div
                                        class="w-2 h-2 bg-black rounded-full"></div>}</div>
                                <div class="w-20 h-8 border-t-2 border-black mt-auto flex justify-center">
                                    <div
                                        class="w-12 h-16 bg-white border-2 border-black rounded-b-lg -mt-4 flex justify-center pt-2">
                                        <div class="w-1 h-8 bg-black mx-1"></div>
                                        <div class="w-4 h-8 bg-black/20 mx-1"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div><button (click)="handleProcessPayment()"
                        class="w-full max-w-[400px] h-[72px] bg-[#FF0000] text-white  md: font-bold rounded shadow-lg hover:bg-red-700 transition-all active:scale-95">{{
                        'PAYMESTR0014' | translate }}</button>
                </div>
                }
                @case('cash') {
                <div class="flex flex-col h-full items-center">
                    <div class="w-full flex justify-between items-end border-b-2 border-gray-100 pb-6 mb-12">
                        <div class="text-left">
                            <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0002' |
                                translate }}</div>
                            <div class="fs-26 fw-600 text-gray-900">{{ totalPayment() |
                                number }} {{'USERMAG0048' | translate}}</div>
                        </div>
                        <div class="text-right">
                            <div class="flex gap-6">
                                <div>
                                    <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0019' |
                                        translate }}</div>
                                    <p-inputnumber styleClass="w-[200px] h-[40px]" inputId="integeronly"
                                        [(ngModel)]="RECV_AMT"
                                        (ngModelChange)="Change_AMT = RECV_AMT- totalPayment() > 0 ? RECV_AMT- totalPayment() : 0"
                                        inputStyleClass="fs-26 fw-600 w-[200px] h-[40px]" />
                                </div>

                                <div>
                                    <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0070' |
                                        translate }}</div>
                                    <p-inputnumber styleClass="w-[200px] h-[40px]" inputId="integeronly"
                                        [ngModel]="Change_AMT" disabled
                                        inputStyleClass="fs-26 fw-600 w-[200px] h-[40px]" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 flex items-center justify-center mb-12 p-8">
                        <div class="relative">
                            <div
                                class="w-32 h-40 border-4 border-black rounded-lg bg-white flex flex-col items-center pt-4 relative">
                                <div
                                    class="w-12 h-12 rounded-full border-2 border-orange-400 flex items-center justify-center mb-2 bg-orange-100">
                                    <span class="font-bold  text-black">₩</span>
                                </div>
                                <div class="w-16 h-1 bg-blue-300 rounded mb-1"></div>
                                <div class="w-16 h-1 bg-blue-300 rounded mb-3"></div>
                                <div class="w-full h-8 border-t-4 border-black mt-auto rounded-b-lg"></div>
                                <div
                                    class="absolute -left-2 top-8 w-4 h-8 bg-white border-l-4 border-t-4 border-b-4 border-black rounded-l-lg">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row gap-4 md:gap-6 w-full max-w-[600px] justify-center"><button
                            (click)="handleProcessPayment(paymentType.Cash)"
                            class="flex-1 h-[60px] md:h-[72px] bg-[#FF0000] text-white  md: font-bold rounded shadow-lg hover:bg-red-700 transition-all active:scale-95">{{
                            'PAYMESTR0020' | translate }}</button><button
                            (click)="handleProcessPayment(paymentType.CashBill)"
                            class="flex-1 h-[60px] md:h-[72px] bg-[#FF0000] text-white  md: font-bold rounded shadow-lg hover:bg-red-700 transition-all active:scale-95">{{
                            'PAYMESTR0021' | translate }}</button></div>
                </div>
                }
                @case('easypay') {
                <div class="flex flex-col h-full items-center">
                    <div class="w-full flex justify-between items-end border-b-2 border-gray-100 pb-6 mb-12">
                        <div class="text-left">
                            <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0036' |
                                translate }}</div>
                            <div class="fs-26 fw-600 text-gray-900">{{ totalPayment() |
                                number }} {{'USERMAG0048'| translate}}</div>
                        </div>
                        <div class="text-right">
                            <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0016' |
                                translate }}</div>
                            <input type="text" class="w-[200px] h-[40px] fs-26 fw-600" pInputText min="0"
                                [value]="(totalPayment() | number) + ' ' + ('USERMAG0048'| translate)" disabled>

                        </div>
                    </div>
                    <div class="flex justify-between fw-700 items-center h-full fs-20">
                        COMING SOON!!!
                    </div>
                    <!-- <div class="flex justify-center fs-16 fw-600">
                        {{'PAYMESTR0051' | translate}}: {{selectedEasyPayment?.comM_D_NM}}
                    </div>
                    <div class="flex-1 flex items-center justify-center mb-12 p-8">
                        <div class="relative">
                            <div
                                class="w-32 h-56 border-4 border-black rounded-3xl bg-white flex flex-col items-center justify-center relative">
                                <div class="absolute top-2 w-8 h-1 bg-black rounded-full"></div>
                                <div
                                    class="w-24 h-16 border-2 border-black rounded-lg flex flex-col justify-end p-1 relative bg-white z-10">
                                    <div class="w-full h-2 bg-black rounded-sm mb-1"></div>
                                </div>
                                <div class="absolute bottom-4 w-4 h-4 border-2 border-black rounded-full"></div>
                                <div
                                    class="absolute top-20 -right-6 w-20 h-12 bg-white border-2 border-black rounded-lg rotate-[-10deg] flex flex-col p-1 z-0">
                                    <div class="w-full h-2 bg-black mt-1"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row gap-4 md:gap-6 w-full max-w-[600px] justify-center p-8">
                        <button (click)="visibleEasypayment = true"
                            class="flex-1 h-[60px] md:h-[72px] bg-[#FF0000] text-white  md: font-bold rounded shadow-lg hover:bg-red-700 transition-all active:scale-95">{{
                            'PAYMESTR0051' | translate }}</button>
                        <button (click)="handleProcessPayment()"
                            class="flex-1 h-[60px] md:h-[72px] bg-[#FF0000] text-white  md: font-bold rounded shadow-lg hover:bg-red-700 transition-all active:scale-95">{{
                            'PAYMESTR0018' | translate }}</button>
                    </div> -->
                    <!-- <button (click)="handleProcessPayment()"
                        class="w-full max-w-[400px] h-[72px] bg-[#FF0000] text-white  font-bold rounded shadow-lg hover:bg-red-700 transition-all active:scale-95">{{
                        'PAYMESTR0018' | translate }}</button> -->
                </div>
                }
                @case('points') {
                <div class=" flex flex-col h-full items-center">
                    <div class="w-full flex justify-between items-end border-b-2 border-gray-100 pb-6 mb-12">
                        <div class="text-left">
                            <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0036' |
                                translate }}</div>
                            <div class="fs-26 fw-600 text-gray-900">{{ totalPayment() |
                                number }} {{'USERMAG0048'| translate}}</div>
                        </div>
                        <div class="text-right">
                            <div class=" text-gray-900 mb-1">{{ 'PAYMESTR0022' |
                                translate }}</div>
                            <input type="text" class="w-[200px] h-[40px] fs-26 fw-600" pInputText min="0"
                                [value]="(totalPayment() | number) + ' ' + ('USERMAG0048'| translate)" disabled>
                            <!-- <div class="fs-26 fw-600 text-gray-900">{{ totalPayment() |
                                number }} {{'USERMAG0048'| translate}}</div> -->
                        </div>
                    </div>
                    <div class="flex-1 w-full max-w-[600px] flex flex-col justify-center gap-6 mb-8 p-8">
                        <div class="flex flex-col md:flex-row items-stretch md:items-center gap-2 md:gap-4">
                            <div
                                class="h-12 md:h-14 bg-[#443C3A] text-white  flex items-center justify-center rounded-lg shadow-sm md:w-40 p-3">
                                {{ 'PAYMESTR0023' | translate }}</div>
                            <div
                                class="flex-1 h-12 md:h-14 bg-[#D9D9D9] p-2 border border-black  md: font-bold flex items-center justify-start rounded-lg">
                                {{member().hP_NO | phoneFormat}}</div>
                        </div>
                        <div class="flex flex-col md:flex-row items-stretch md:items-center gap-2 md:gap-4">
                            <div
                                class="h-12 md:h-14 bg-[#443C3A] text-white  flex items-center justify-center rounded-lg shadow-sm md:w-40 p-3">
                                {{ 'PAYMESTR0024' | translate }}</div>
                            <div
                                class="flex-1 h-12 md:h-14 bg-[#D9D9D9] border border-black p-2 md: font-bold flex items-center justify-start rounded-lg">
                                {{member().savE_CHARGE_AMT | number}} {{'USERMAG0048' | translate}}</div>
                        </div>
                    </div>
                    <div class="flex flex-col md:flex-row gap-4 md:gap-6 w-full max-w-[600px] justify-center p-8">
                        <button (click)="checkBalance()"
                            class="flex-1 h-[60px] md:h-[72px] bg-[#FF0000] text-white  md: font-bold rounded shadow-lg hover:bg-red-700 transition-all active:scale-95">{{
                            'PAYMESTR0025' | translate }}</button>
                        <button (click)="handleProcessPayment()"
                            class="flex-1 h-[60px] md:h-[72px] bg-[#FF0000] text-white  md: font-bold rounded shadow-lg hover:bg-red-700 transition-all active:scale-95">{{
                            'PAYMESTR0028' | translate }}</button>
                    </div>
                </div>
                }
                @case('complete') {
                <div
                    class="p-8 flex flex-col h-full items-center justify-center border-4 border-[#5D5D5D] m-4 rounded-2xl relative">
                    <div class="text-center mb-12">
                        <h2 class="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4 tracking-tight">{{
                            'PAYMESTR0029' | translate }}</h2>
                        <p class=" md: text-gray-500 font-medium">{{ 'PAYMESTR0030' | translate:
                            {countdown: countdown()} }}</p>
                    </div>
                    <div class="mb-16">
                        <div
                            class="w-32 h-40 border-4 border-black rounded-lg flex flex-col items-center pt-6 relative">
                            <div class="w-20 h-1 bg-blue-300 rounded mb-2"></div>
                            <div class="w-20 h-1 bg-blue-300 rounded mb-2"></div>
                            <div class="w-20 h-1 bg-blue-300 rounded mb-2"></div>
                            <div
                                class="absolute -left-2 top-6 w-4 h-8 bg-white border-l-4 border-t-4 border-b-4 border-black rounded-l-lg">
                            </div>
                            <div class="w-full h-8 border-t-4 border-black mt-auto rounded-b-lg"></div>
                        </div>
                    </div><button (click)="handleCompleteClose()"
                        class="w-full max-w-[400px] h-[72px] bg-[#5D5D5D] text-white  font-bold rounded shadow-lg hover:bg-[#4a4a4a] transition-all active:scale-95">{{
                        'PAYMESTR0031' | translate }}</button>
                </div>
                }
                }
            </div>
        </div>
        }
    </div>

    <!-- Right Column (Cart) -->
    @if(cart().length > 0){
    <div class="w-full md:w-[300px] 2xl:w-[450px] bg-white border-l border-gray-400 flex flex-col flex-shrink-0 z-30 shadow-2xl lg:shadow-none transition-all duration-300 ease-in-out border-t lg:border-t-0 absolute lg:static bottom-0 left-0 lg:h-full"
        [class.h-full]="isMobileCartExpanded()" [class.h-[72px]]="!isMobileCartExpanded()">
        <app-cart [cart]="cart()" [(isMobileCartExpanded)]="isMobileCartExpanded" [viewMode]="viewMode()"
            (updateQuantity)="updateQuantity($event.product, $event.delta)" [paymentReservation]="paymentReservation()"
            (updateQuantityInput)="updateQuantityInput($event.product, $event.delta)"
            (cancelPaymentReservation)="cancelPaymentReservation()" (removeFromCart)="removeFromCart($event)"
            (goToPayment)="handlePaymentClick()" (removeAllFromCart)="cart.set([]); member.set(null)"
            (selectedUser)="selectedUser.set($event)" [DISCOUNT_AMT]="DISCOUNT_AMT()">
        </app-cart>
    </div>
    }

    <!-- <app-product-detail-modal [product]="selectedProductForModal()" (close)="handleCloseModal()"
        (addToCart)="addToCart($event)">
    </app-product-detail-modal> -->

    <div *ngIf="openMemberSearch()">
        <components-member-search [open]="openMemberSearch()" (close)="closeMemberSearch()"
            (memberSearch)="member.set($event)"></components-member-search>
    </div>
</div>

<!-- <div class="card flex justify-center">
    <p-dialog [header]="'PAYMESTR0051' | translate" [modal]="true" [(visible)]="visibleEasypayment"
        styleClass="w-[40vw] 2xl:w-[25vw]">
        <div class="grid grid-cols-3 gap-4 w-full">
            <div *ngFor="let g of easyPayments" class="w-full">
                <button (click)="selectedEasyPay(g)"
                    class="w-full text-center p-2  rounded-lg transition-colors border text-ellipsis min-w-[100px]"
                    [class.font-bold]="selectedEasyPayment?.comM_D_CD === g.comM_D_CD"
                    [class.bg-gray-700]="selectedEasyPayment?.comM_D_CD === g.comM_D_CD"
                    [class.text-white]="selectedEasyPayment?.comM_D_CD === g.comM_D_CD"
                    [class.border-gray-400]="selectedEasyPayment?.comM_D_CD === g.comM_D_CD"
                    [class.shadow-sm]="selectedEasyPayment?.comM_D_CD === g.comM_D_CD"
                    [class.text-gray-800]="selectedEasyPayment?.comM_D_CD === g.comM_D_CD"
                    [class.bg-gray-100]="selectedEasyPayment?.comM_D_CD !== g.comM_D_CD"
                    [class.border-gray-200]="selectedEasyPayment?.comM_D_CD !== g.comM_D_CD"
                    [class.text-gray-500]="selectedEasyPayment?.comM_D_CD !== g.comM_D_CD"
                    [class.hover:bg-gray-200]="selectedEasyPayment?.comM_D_CD !== g.comM_D_CD">
                    {{ g.comM_D_NM }}
                </button>

            </div>
        </div>
    </p-dialog>
</div> -->

@if(loading()){
<div class="loading-overlay">
    <div class="flex flex-col justify-center gap-4">
        <div class="flex items-center justify-center text-white w-full">
            <p>{{ loadingText() }}</p>
        </div>
        <div class="flex justify-center w-full">
            <div class="loader"></div>
        </div>
    </div>
</div>
}